export default __webpack_public_path__ + "static/media/mic.b1efbe1e.svg";